// extracted by mini-css-extract-plugin
export default {"modal":"formAuth_modal__TvRmn"};